import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { IntegrityMonitorDetailedAssignationData } from '../types';
import { IntegrityMonitorRuleGridItem } from '../../integrityMonitorRulesGrid/types';
import { Target } from '@nirvana/shared/company-helper/nestjs';

export abstract class IntegrityMonitorRulesAppBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getRuleDetailedAssignationData(
    rulesIds: Array<string>
  ): Promise<IntegrityMonitorDetailedAssignationData>;

  public abstract removeRecords(records): Promise<any>;

  public abstract deleteRuleSet(ruleSetId: string, companyId: string): Promise<Object | null>;

  public abstract readRuleOriginal(templateId: string): Promise<IntegrityMonitorRuleGridItem>;

  public abstract updateNonConfigurableDefaultRule(rule: IntegrityMonitorRuleGridItem): Promise<any>;

  public abstract getAvailableCompanies(): Promise<Target[]>;
}
